module.exports = __webpack_public_path__ + "img/developer-part3-3.a15eed63.png";